import { type PictogramIconProps } from './types';

// line_graph_arrow_thick
export const LineGraphArrowThick = ({ color }: PictogramIconProps) => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.9152 11.6176C36.9914 11.6176 36.2425 12.3606 36.2425 13.2772C36.2425 14.1938 36.9914 14.9369 37.9152 14.9369H47.2587L30.1091 31.9525L20.1404 22.0616C19.4872 21.4135 18.4281 21.4135 17.7748 22.0616L1.04755 38.6582C0.394307 39.3063 0.394307 40.3572 1.04755 41.0053C1.70079 41.6535 2.7599 41.6535 3.41314 41.0053L18.9576 25.5823L28.9263 35.4731C29.5796 36.1213 30.6387 36.1213 31.2919 35.4731L49.6243 17.284V26.5545C49.6243 27.4711 50.3732 28.2141 51.297 28.2141C52.2208 28.2141 52.9697 27.4711 52.9697 26.5545V13.2772C52.9697 12.8525 52.8064 12.4277 52.4798 12.1037C52.3194 11.9445 52.1346 11.8245 51.9373 11.7435C51.7401 11.6623 51.5238 11.6176 51.297 11.6176H37.9152Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
};
